module.exports = __webpack_public_path__ + "static/img/blog-08.9865c4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog/blog-08.jpg
// module id = 6W9o
// module chunks = 0